import { StockInfo, Supplier } from '../types/generated';
import moment from 'moment';
import classNames from 'classnames';

interface StockIndicatorProps {
  stockInfo: StockInfo;
  showMessages?: boolean;
  singleLine?: boolean;
  supplierID: number;
  isThirdPartyDDelivery?: boolean | null;
  isRestricted?: boolean | null;
  suppressStockDeliveryMessage?: boolean | null;
}

const StockIndicator = ({
  stockInfo,
  showMessages,
  singleLine,
  supplierID,
  isThirdPartyDDelivery,
  isRestricted,
  suppressStockDeliveryMessage = false
}: StockIndicatorProps) => {
  const preOrderDateFormatted = moment(stockInfo?.preOrderDate).format(
    'MMMM YYYY'
  );

  const outOfStockCssSuffix = stockInfo.isOutOfStock ? 'out' : 'delayed';

  const singleLineClass = classNames({
    'd-flex flex-column': singleLine
  });

  const customPadding = singleLine ? ' pr-1' : '';
  const delayedStock = () => {
    return (
      <>
        <div
          className={`stock-indicator stock-indicator--${outOfStockCssSuffix}${customPadding}${
            !singleLine && stockInfo.isDelayedStock && showMessages
              ? ' flex-50'
              : ''
          }`}
        >
          Out of stock
        </div>

        {stockInfo.isDelayedStock && showMessages && (
          <p className={`${singleLine ? 'mb-0' : 'mb-0 flex-50'}`}>
            <span className="d-sm-block d-xl-inline">
              {' '}
              {stockInfo.expectedBackInStockMessage}
            </span>
          </p>
        )}
      </>
    );
  };

  const delayedStockThirdParty = () => {
    return (
      <>
        {stockInfo.isInStock && isThirdPartyDDelivery && (
          <p className="mb-0">
            <span className="d-sm-block d-xl-inline">
              {' '}
              {stockInfo.thirdPartyDirectDeliveryMessage}
            </span>
          </p>
        )}
      </>
    );
  };

  const preOrder = () => {
    return (
      <>
        <div
          className={`stock-indicator stock-indicator--preorder${customPadding}`}
        >
          Pre-order
        </div>
        {showMessages && (
          <p className="mb-0">
            {': '}Order now, delivery expected in
            <span className="d-sm-block d-xl-inline">
              {' '}
              {preOrderDateFormatted}
            </span>
          </p>
        )}
      </>
    );
  };

  return (
    <>
      {stockInfo.isStockRelevant &&
        stockInfo?.stockLevel != null &&
        !stockInfo?.isPreOrder &&
        supplierID === Supplier.Findel && (
          <div className="basket-row">
            <div className="basket-row__label w-100">
              {stockInfo.isInStock && (
                <div className="stock-indicator">
                  In stock
                  {stockInfo.inStockDeliveryMessage !== '' &&
                    !suppressStockDeliveryMessage &&
                    !isRestricted &&
                    !isThirdPartyDDelivery && (
                      <span>
                        {' - '}
                        {stockInfo.inStockDeliveryMessage}
                      </span>
                    )}
                </div>
              )}
              {!singleLine &&
                (stockInfo.isDelayedStock || stockInfo.isOutOfStock) && (
                  <>{delayedStock()}</>
                )}
              {singleLine &&
                (stockInfo.isDelayedStock || stockInfo.isOutOfStock) && (
                  <div className={singleLineClass}>{delayedStock()}</div>
                )}
              {stockInfo.isInStock && isThirdPartyDDelivery && (
                <div className={singleLineClass}>
                  {delayedStockThirdParty()}
                </div>
              )}
            </div>
          </div>
        )}
      {stockInfo.isStockRelevant && !singleLine && stockInfo?.isPreOrder && (
        <div className="basket-row">
          <div className="basket-row__label w-100">{preOrder()}</div>
        </div>
      )}
      {stockInfo.isStockRelevant && singleLine && stockInfo?.isPreOrder && (
        <div className="basket-row">
          <div className="basket-row__label">
            <div className={singleLineClass}>{preOrder()}</div>
          </div>
        </div>
      )}
    </>
  );
};

export default StockIndicator;
